var map = {
	"./computer/Holder/Holder.vue": [
		"3059",
		"chunk-6f94efae"
	],
	"./mobile/Holder/Holder.vue": [
		"847f",
		"chunk-00390b57"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4a4d";
module.exports = webpackAsyncContext;